import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { APP_CONFIG, AppConfig } from '../../app.config';

@Injectable({
    providedIn: 'root'
})
export class DocumentService {
    private downloadDocumentURL: string;

    constructor(
        private http: HttpClient,
        @Inject(APP_CONFIG) private config: AppConfig
    ) {
        this.downloadDocumentURL = `${this.config.docViewAPI}/downloadorchestration/multidata`;
    }

    downloadDocument(requestParam: any): Observable<any> {
        return this.http.post(this.downloadDocumentURL, requestParam).pipe(
            map((res) => res),
            catchError((error) => {
                console.error('Error downloading document:', error);
                return throwError(error);
            })
        );
    }

    /**
     * Fetches the document link for an inbound communication via the task content API.
     * Returns the Arrender-ready URL string extracted from the nested response body.
     * Response shape: { data: { statusCode, domain, body: '{"doclink":"..."}' } }
     */
    getInboundTaskContent(taskId: string): Observable<string> {
        const url = `${this.config.irisTaskURL}/${taskId}/content`;
        const headers = new HttpHeaders({ 'x-api-key': this.config.irisApiKey });

        return this.http.get<{ data: { statusCode: number; domain: string; body: string } }>(url, { headers }).pipe(
            map((res) => {
                const parsed = JSON.parse(res.data.body);
                if (!parsed?.doclink) {
                    throw new Error('doclink missing in task content response');
                }
                return parsed.doclink as string;
            }),
            catchError((error) => {
                console.error('Error fetching inbound task content:', error);
                return throwError(error);
            })
        );
    }

    getDocumentUrl(link: string): string {
        return `${this.config.ArenderURL}${link}${this.config.ArenderProp}`;
    }
}
